export default { PACKAGE_VERSION: "1.5.0" };
